import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {validateTokenStorage} from './../../Constants/Util';
import { Row, Col, Container, Button, Label, Input, ButtonGroup } from "reactstrap";
import { getSetup, putSetup } from "../../Constants/Services";
import { ModalSaved } from "./../../Constants/Modal";
import { ISetup } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface ISetupState {
  dataFormSetup: ISetup;
  isOpenModalSaved: boolean;
  loading: boolean;
}

class Setup extends Component<RouteComponentProps<{}>, ISetupState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      isOpenModalSaved: false,
      loading: false,
    };

    this.fetchSetup = this.fetchSetup.bind(this);
    this.onChangeSetup = this.onChangeSetup.bind(this);
    this.handlerModalSaved = this.handlerModalSaved.bind(this);
    this.setTrimestre = this.setTrimestre.bind(this);
    this.handlerPutSetup = this.handlerPutSetup.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
      loading: false,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchSetup();
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchSetup();
    }, 1000);
  }

  handlerPutSetup() {
    const props = this.state.dataFormSetup;
    const body = {
      set_registrationy: props.set_registrationy,
      set_aniolectivo: props.set_aniolectivo,
      set_startpactivo: props.set_startpactivo,
      set_endpactivo: props.set_endpactivo,
      set_start_ft: props.set_start_ft,
      set_end_ft: props.set_end_ft,
      set_start_st: props.set_start_st,
      set_end_st: props.set_end_st,
      set_start_tt: props.set_start_tt,
      set_end_tt: props.set_end_tt,
      set_trimestre: props.set_trimestre,
    };
    putSetup(body);
    this.setState({ isOpenModalSaved: true });

    setTimeout(() => {
      this.handlerModalSaved();
      this.fetchSetup();
    }, 1500);
  }

  onChangeSetup(e: any) {
    this.setState({
      dataFormSetup: {
        ...this.state.dataFormSetup,
        [e.target.name]: e.target.value,
      },
    });
  }

  handlerModalSaved() {
    this.setState((prevState) => ({
      isOpenModalSaved: !prevState.isOpenModalSaved,
    }));
  }

  setTrimestre = (set_trimestre: string) => {
    this.setState({
      dataFormSetup: {
        ...this.state.dataFormSetup,
        set_trimestre,
      },
    });
  };

  onChangeDatePicker(name: string, date: string) {
    this.setState({
      dataFormSetup: {
        ...this.state.dataFormSetup,
        [name]: date,
      },
    });
  }
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalSaved && <ModalSaved isOpen={props.isOpenModalSaved} toggle={this.handlerModalSaved} />}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center mb-4">
                  <h3>Configuracion de año lectivo</h3>
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={3} className="text-left">
                      <Label className="font-weight-bold">Año: </Label>
                    </Col>
                    <Col sm={9} className="text-left">
                      <Input
                        type="text"
                        name="set_aniolectivo"
                        onChange={this.onChangeSetup}
                        value={props.dataFormSetup.set_aniolectivo}
                        id="set_aniolectivo"
                        placeholder="Año:"
                      />
                    </Col>
                    <Col sm={3} className="text-left mt-3">
                      <Label className="font-weight-bold">Matricula: </Label>
                    </Col>
                    <Col sm={9} className="text-left mt-3">
                      <Input
                        type="text"
                        name="set_registrationy"
                        onChange={this.onChangeSetup}
                        value={props.dataFormSetup.set_registrationy}
                        id="set_registrationy"
                        placeholder="Matricula:"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="text-left mt-3">
                      <Label className="font-weight-bold">Trimestre: </Label> <br></br>
                      <ButtonGroup>
                        <Button
                          outline
                          color="primary"
                          onClick={() => this.setTrimestre("I")}
                          active={props.dataFormSetup.set_trimestre === "I" ? true : false}
                        >
                          I Trimestre
                        </Button>
                        <Button
                          outline
                          color="danger"
                          onClick={() => this.setTrimestre("II")}
                          active={props.dataFormSetup.set_trimestre === "II" ? true : false}
                        >
                          II Trimestre
                        </Button>
                        <Button
                          outline
                          color="info"
                          onClick={() => this.setTrimestre("III")}
                          active={props.dataFormSetup.set_trimestre === "III" ? true : false}
                        >
                          III Trimestre
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={12}>
                      <Label className="font-weight-bold">Periodo activo </Label>
                      <br></br>
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">De:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_startpactivo)}
                        onChange={(date: string) => this.onChangeDatePicker("set_startpactivo", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">Hasta:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_endpactivo)}
                        onChange={(date: string) => this.onChangeDatePicker("set_endpactivo", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="text-left">
                      <Label className="font-weight-bold lh-40">I Trimestre</Label>
                      <br></br>
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">De:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_start_ft)}
                        onChange={(date: string) => this.onChangeDatePicker("set_start_ft", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">Hasta:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_end_ft)}
                        onChange={(date: string) => this.onChangeDatePicker("set_end_ft", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="text-left">
                      <Label className="font-weight-bold lh-40">II Trimestre</Label>
                      <br></br>
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">De:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_start_st)}
                        onChange={(date: string) => this.onChangeDatePicker("set_start_st", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">Hasta:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_end_st)}
                        onChange={(date: string) => this.onChangeDatePicker("set_end_st", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="text-left">
                      <Label className="font-weight-bold lh-40">III Trimestre</Label>
                      <br></br>
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">De:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_start_tt)}
                        onChange={(date: string) => this.onChangeDatePicker("set_start_tt", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                    <Col sm={2} className="text-left">
                      <Label className="font-weight-bold lh-40">Hasta:</Label>
                    </Col>
                    <Col sm={10} className="text-left">
                      <DatePicker
                        selected={new Date(props.dataFormSetup.set_end_tt)}
                        onChange={(date: string) => this.onChangeDatePicker("set_end_tt", date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control w-100"
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>

                  <Button color="success" onClick={this.handlerPutSetup}>
                    Guardar
                  </Button>
                  <Button color="danger" className="ml-2" onClick={this.fetchSetup}>
                    Cancelar
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Setup;
